import { useEffect, useState } from 'react';
import { Form, InputGroup, Button, Badge, Spinner } from 'react-bootstrap';
import { CopyIcon, CheckIcon } from './icons';
import BsaleWebhookClient from '../services/bsalewebhookclient';

const COOKIE_STORAGE_KEY = 'bsale_account_cookie';

function BsaleHook(props) {
  const [copied, setCopied] = useState(false);
  const [cookie, setCookie] = useState(
    () => window.localStorage.getItem(COOKIE_STORAGE_KEY) || ''
  );
  const [cookieInput, setCookieInput] = useState('');
  const [statusError, setStatusError] = useState('');
  const [checkingStatus, setCheckingStatus] = useState(false);
  const [registered, setRegistered] = useState(null);
  const [registering, setRegistering] = useState(false);

  const webhook_url = `${process.env.REACT_APP_API_URL}/bsale/hook/listener/${props.site_name}`;
  const client = new BsaleWebhookClient(props.lp_access_token);

  const checkStatus = async () => {
    if (!cookie || !props.access_token_bsale) return;

    setCheckingStatus(true);
    const result = await client.status(
      props.access_token_bsale, cookie, webhook_url
    );
    setRegistered(!!result.registered);
    setStatusError(result.status && result.status !== 'ok' ? result.message : '');
    setCheckingStatus(false);
  };

  useEffect(() => {
    checkStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cookie, props.access_token_bsale]);

  const onCopy = async () => {
    await navigator.clipboard.writeText(webhook_url);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const onSaveCookie = () => {
    const value = cookieInput.trim();
    window.localStorage.setItem(COOKIE_STORAGE_KEY, value);
    setCookie(value);
    setCookieInput('');
  };

  const onDisconnect = () => {
    window.localStorage.removeItem(COOKIE_STORAGE_KEY);
    setCookie('');
    setRegistered(null);
    setStatusError('');
  };

  const onRegister = async () => {
    setRegistering(true);
    const result = await client.register(
      props.access_token_bsale, cookie, webhook_url
    );

    if (result.status === 'ok') {
      await checkStatus();
    } else if (result.status === 'session_error') {
      setStatusError(result.message);
    } else {
      alert(result.message || 'No se pudo registrar el webhook');
    }
    setRegistering(false);
  };

  return (
    <>
      <InputGroup>
        <Form.Control
          onFocus={(e) => e.target.select()}
          readOnly={true}
          type="text"
          value={webhook_url}
        />
        <Button variant="outline-secondary" className="copy-button" type="button" onClick={onCopy}>
          {copied ? <CheckIcon /> : <CopyIcon />}
          {copied ? 'Copiado' : 'Copiar'}
        </Button>
      </InputGroup>

      <div className="bsale-webhook-status mt-2">
        {!cookie ? (
          <div className="d-flex flex-column gap-2">
            <Form.Text className="text-muted">
              Para registrar este webhook desde acá, inicia sesión en{' '}
              <a href="https://account.bsale.dev/login" target="_blank" rel="noreferrer">
                account.bsale.dev
              </a>
              , abre DevTools → Application → Cookies y copia el valor de la
              cookie <code>bsale-session</code>.
            </Form.Text>
            <Form.Control
              size="sm"
              type="password"
              placeholder="Cookie bsale-session"
              value={cookieInput}
              onChange={(e) => setCookieInput(e.target.value)}
            />
            <Button
              size="sm"
              variant="outline-primary"
              type="button"
              disabled={!cookieInput.trim()}
              onClick={onSaveCookie}
            >
              Usar sesión BSale
            </Button>
          </div>
        ) : (
          <div className="d-flex align-items-center gap-2 flex-wrap">
            {checkingStatus ? (
              <Spinner animation="border" size="sm" />
            ) : statusError ? (
              <Badge bg="danger" pill>{statusError}</Badge>
            ) : registered ? (
              <Badge bg="success" pill>Webhook registrado</Badge>
            ) : (
              <Badge bg="secondary" pill>No registrado</Badge>
            )}
            {!checkingStatus && !registered && !statusError && (
              <Button
                size="sm"
                variant="warning"
                type="button"
                disabled={registering || !props.access_token_bsale}
                onClick={onRegister}
              >
                {registering ? 'Registrando...' : 'Registrar webhook'}
              </Button>
            )}
            <Button
              size="sm"
              variant="link"
              type="button"
              className="text-muted"
              onClick={onDisconnect}
            >
              Cambiar sesión BSale
            </Button>
          </div>
        )}
      </div>

      <Form.Text className="text-muted">
        <b>cpn id: </b> {props.company.id}<br/>
        <b>empresa: </b>{props.company.name}<br/>
        <b>rut: </b> {props.company.code}<br/>
        <b>país: </b> {props.company.country}<br/>
      </Form.Text>
    </>
  );
}

export default BsaleHook;
